var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { memo } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Text } from 'pcln-design-system';
var IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "PackagesFill__IconWrapper",
  componentId: "sc-bnbkqs-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
function BaseComponent(_a) {
  var title = _a.title,
    titleId = _a.titleId,
    props = __rest(_a, ["title", "titleId"]);
  var themeContext = React.useContext(ThemeContext);
  var themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", __assign({
    width: '1em',
    height: '1em',
    viewBox: '0 0 24 24',
    xmlns: 'http://www.w3.org/2000/svg',
    focusable: false,
    "aria-hidden": true,
    role: 'img',
    "aria-labelledby": titleId
  }, props), title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("g", {
    fill: 'none',
    fillRule: 'evenodd'
  }, React.createElement("path", {
    d: 'M1.005 19.176L1 19V9a3 3 0 012.824-2.995L4 6h1V2h-.5a.5.5 0 01-.09-.992L4.5 1h7a.5.5 0 01.09.992L11.5 2H11v4h1a3 3 0 012.995 2.824L15 9V4h-.5a.5.5 0 01-.09-.992L14.5 3h6a.5.5 0 01.09.992L20.5 4H20v6a3 3 0 012.995 2.824L23 13v6a3 3 0 01-2.824 2.995L20 22c0 .552-.336 1-.75 1s-.75-.448-.75-1h-2c0 .552-.336 1-.75 1s-.75-.448-.75-1c-.547 0-1.06-.146-1.5-.402-.379.22-.809.358-1.268.393L12 22c0 .566-.448 1.025-1 1.025s-1-.459-1-1.025H6a1 1 0 01-2 0 3 3 0 01-2.995-2.824zM19 10V4h-3v6h3zm-9-8H6v4h4V2z',
    fill: themeGet('palette.primary.base')(themeProps)
  }), React.createElement("path", {
    d: 'M20 11a2 2 0 012 2v6l-.005.15A2 2 0 0120 21h-5l-.174-.007a1.967 1.967 0 01-.493-.107A2.987 2.987 0 0015 19v-8zm-3 1.5a.5.5 0 00-.5.5v6l.008.09A.5.5 0 0017.5 19v-6l-.008-.09A.5.5 0 0017 12.5zm2.5 0a.5.5 0 00-.5.5v6l.008.09A.5.5 0 0020 19v-6l-.008-.09a.5.5 0 00-.492-.41z',
    fillOpacity: 0.9,
    fill: themeGet('palette.primary.light')(themeProps)
  }), React.createElement("path", {
    d: 'M4.5 9a.5.5 0 00-.492.41L4 9.5V19l.008.09a.5.5 0 00.984 0L5 19V9.5l-.008-.09A.5.5 0 004.5 9zM8 9a.5.5 0 00-.492.41L7.5 9.5V19l.008.09a.5.5 0 00.984 0L8.5 19V9.5l-.008-.09A.5.5 0 008 9zm3.5 0a.5.5 0 00-.492.41L11 9.5V19l.008.09a.5.5 0 00.984 0L12 19V9.5l-.008-.09A.5.5 0 0011.5 9z',
    fill: themeGet('palette.background.lightest')(themeProps)
  })));
}
var PackagesFill = function (props) {
  return React.createElement(IconWrapper, {
    fontSize: props.size,
    lineHeight: props.size,
    verticalAlign: 'middle',
    className: props.className
  }, React.createElement(BaseComponent, null));
};
/** @public */
var Memo = memo(PackagesFill);
export default Memo;
var templateObject_1;